// React hook for authentication state management

import { useEffect, useState } from 'react'
import { authService, AuthState, AuthUser } from '../lib/auth'

export function useAuth() {
  const [authState, setAuthState] = useState<AuthState>(() => authService.getState())

  useEffect(() => {
    const unsubscribe = authService.subscribe(setAuthState)
    return unsubscribe
  }, [])

  const login = async (email: string, password: string) => {
    await authService.login(email, password)
  }

  const logout = async () => {
    await authService.logout()
  }

  return {
    // State
    user: authState.user,
    isAuthenticated: authState.isAuthenticated,
    isLoading: authState.isLoading,
    error: authState.error,
    
    // Actions
    login,
    logout,
    
    // Utilities
    hasPermission: (permission: string) => authService.hasPermission(permission),
    isAdmin: () => authService.isAdmin(),
    isEditor: () => authService.isEditor(),
    getTenantId: () => authService.getTenantId(),
    getCreditsRemaining: () => authService.getCreditsRemaining()
  }
}